// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CardHeader_wrapper__1Lfln"};